import type { NextPage } from 'next';
import { useMemo } from 'react';

import { useIsMobile } from '@sravni/react-utils';

import BottomBannerContainer from '@src/components/BottomBannerContainer';
import { PageLocationHeader } from '@src/components/PageHeader/PageHeaderLocation/LocationHeader';
import { PageContext } from '@src/config';
import type { IPageContextConfig } from '@src/config/PageContext';
import { BottomBannerTypes } from '@src/constants/bottomBannerTypes';
import { ListKeys } from '@src/constants/microcredits';
import { useBestProducts } from '@src/hooks/useBestProducts';
import { useListPage } from '@src/hooks/useListPage';
import { useSelectUser } from '@src/reducers/user';
import { isBezPhotoPage } from '@src/utils/routing';
import { Layout as AppLayout } from 'app/Layout';
import { useGetHeaderFilters } from 'pageModules/ListPage/lib';
import { BrandingHeaders } from 'widgets/BrandingHeaders';
import { SeoComponents } from 'widgets/SeoComponents';

import styles from './BezOtkazaPage.module.scss';

const pageConfig: IPageContextConfig = {
  listKey: ListKeys.LIST,
  source: 'search',
  sortPanelVisible: true,
  seoLinksVisible: true,
  extraFiltersVisible: true,
  cardTermIsVisible: true,
  withBanners: true,
  withInvitationBanner: true,
  withEmailBurner: true,
  withSelectionBanner: true,
  withCardProductLink: true,
  isMainPage: true,
};

export const BezOtkazaPage: NextPage = () => {
  const isMobile = useIsMobile();
  const { seo, filter, asPath } = useListPage(ListKeys.LIST);
  const user = useSelectUser();

  const { Filters } = useGetHeaderFilters(filter, seo, user);

  const config = useMemo(() => ({ ...pageConfig, withMonetizationCardLogoClick: isMobile }), [isMobile]);
  const isBezPhoto = isBezPhotoPage(asPath);

  useBestProducts();

  const AfterHeaderVariant = useMemo(() => {
    if (isBezPhoto && isMobile) {
      return <PageLocationHeader className={styles.page_header_title} header={seo.heading} />;
    }
    if (isMobile) {
      return Filters;
    }
    return null;
  }, [isBezPhoto, isMobile, seo.heading, Filters]);

  return (
    <AppLayout>
      <PageContext.Provider value={config}>
        <BrandingHeaders containerClassName={styles.page_header} afterHeaders={AfterHeaderVariant} />

        {seo && (
          <SeoComponents
            seo={seo}
            breadcrumbs={seo.breadcrumbs}
            prefooter={seo.prefooter}
            showAnchorLinks={false}
            showSubheader
          />
        )}
        <BottomBannerContainer enabledTypes={[BottomBannerTypes.OUT_OF_PAGE, BottomBannerTypes.SIDEBAR]} />
      </PageContext.Provider>
    </AppLayout>
  );
};

BezOtkazaPage.getInitialProps = () => ({});
